var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mobile-navigation-wrapper",
      class: { active: _vm.activeMenu },
    },
    [
      _c("div", {
        staticClass: "page-overlay",
        class: { active: _vm.activeMenu },
        on: {
          click: function ($event) {
            return _vm.triggerMenu()
          },
        },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-md mobile-navigation-button",
          class: _vm.mobileMenuDisplayPort,
          on: {
            click: function ($event) {
              return _vm.triggerMenu()
            },
          },
        },
        [_vm._v("\n    Menu\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mobile-navigation", class: _vm.mobileMenuDisplayPort },
        [
          _c(
            "div",
            {
              staticClass: "mobile-navigation-container",
              class: _vm.mobileMenuPosition,
            },
            [
              _c("div", { staticClass: "close-menu" }, [
                _c(
                  "div",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.triggerMenu()
                      },
                    },
                  },
                  [_vm._v("\n          Close Menu\n        ")]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _vm.ecommerceEnabled ? _c("ecommerce-cart-block") : _vm._e(),
                  _vm._v(" "),
                  !_vm.loggedIn ? _c("user-login-popup") : _vm._e(),
                  _vm._v(" "),
                  _vm.loggedIn ? _c("page-element-user-my-account") : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.searchActive
                ? _c(
                    "div",
                    { staticClass: "mobile-search" },
                    [
                      _c(
                        "b-input-group",
                        [
                          _c("b-form-input", {
                            attrs: { placeholder: "Site Search" },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-input-group-append",
                            [
                              _c(
                                "b-btn",
                                { attrs: { variant: "info" } },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "searchIcon" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "primary" },
                [
                  _c("main-menu", { attrs: { "menu-style": "mobile" } }),
                  _vm._v(" "),
                  _c("main-menu", {
                    attrs: {
                      "menu-style": "mobile",
                      "menu-name": "main-menu-2",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }